import axios from "axios";
import React, { Component, useState, useEffect, useContext, lazy, Suspense } from "react";
import queryString from "query-string";
import AdModal from '../../app_structure/AdModal';
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import AdSense from 'react-adsense';
import BitmediaAd from '../mission/bitmedia';
import { FaRegClock } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext";
import { ClipLoader } from "react-spinners";
const LazyReCAPTCHA = lazy(() => import("../../app_structure/LazyReCAPTCHA"));
function Capdo12(props) {
  const capdo12 = props.data;
  const note = props.note;
  const [isLoading, setIsLoading] = useState(false);
  const [lienketjop, setlienketjop] = useState("");
  const [disabledbutton, setdisabledbutton] = useState(true);
  const [count, setCount] = useState(15);
  // Gọi hàm alert_error
  const [dataCaptcha, setdataCaptcha] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [lienket, setLienket] = useState("");
  const recaptchaRef = React.createRef();
  const [nutxuly, setnutxuly] = useState("");
  const [buttonTextjop, setbuttonTextjop] = useState("");
  const [loading, setLoading] = useState(false);
  const [api_key, setapi_key] = useState("");
  const [lienketok, setlienketok] = useState("");
  const [code3, setcode3] = useState("");
  const navigate = useNavigate();
  function laydulieu() { }
  function check() { }
  function handleSubmit(event) {
    const hustmediavipro = Cookies.get('hustmediavipro');
    setnutxuly(1);
    event.preventDefault();
    setbuttonTextjop("Please wait a moment 😊");
    const capdovuotlink = Cookies.get('capdovuotlink');
    Cookies.set('capdovuotlink', '', { expires: 1 / 12 });
    const apidata = {
      recaptchaValue: dataCaptcha,
      capdook: capdovuotlink,
      lienket: hustmediavipro
    };
    const headers = {
      'Content-Type': 'application/json'
    }
    axios.post('https://hust.media/link/checktiktok.php', apidata, headers)
      .then(response => handleChange(response.data))
      .catch(error => {
        alert_error(error);
      });
  }
  function handleChange(asdasdasd) {
    if (asdasdasd.status == 1) {
      setnutxuly(0);
      const lienketjop = asdasdasd.order;
      console.log(lienketjop);
      props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
      alert_success('Xác thực thành công');
      setbuttonTextjop("Hust Media cảm ơn bạn đã ghé thăm");
    } else {
      alert_error('Đã xảy ra lỗi tải lại trang nhé');
    }

  }

  const handleRecaptchaChange = (value) => {
    console.log(value);
    const maxLength = 200;

    if (value.length > maxLength) {
      setdataCaptcha(value);
      setbuttonTextjop('Ấn đây để lấy link');
    } else {
      setbuttonTextjop("Đã xảy ra lỗi tải lại trang nhé");
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    if (count == 0) {
      setbuttonTextjop('Xác nhận bạn không phải người máy');
      setdisabledbutton(false);
      clearInterval(intervalId);
      // xử lý khi đếm ngược hoàn thành
    }

    return () => clearInterval(intervalId);
  }, [count]);
  useEffect(() => {

    setIsLoading(true);
    setbuttonTextjop('Đang tải dữ liệu Please wait a moment 😊');
    setTimeout(() => {
      if (capdo12 == 1) {
        setdisabledbutton(false);
        setbuttonTextjop('Xác nhận bạn không phải người máy');
      }
      else if (capdo12 == 2) {

      }

      setIsLoading(false);
      setShowCaptcha(true);
    }, 2700);
    check();
  }, []);
  const [showAd, setShowAd] = useState(true);
  const handleCloseAd = () => {
    setShowAd(false);
  };
  return (
    <div>


      <form className="add-form" onSubmit={handleSubmit}>
        <div className="form-control">
          <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center ">
            <div id="M882924ScriptRootC1520508"></div>
            {capdo12 == 2 ? (
              <>
                <Helmet>
                  <script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script>
                  {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
                  <script data-cfasync="false" type="text/javascript" src="//hhbypdoecp.com/lv/esnk/1978451/code.js" async id="__clb-1978451"></script>
                  <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                </Helmet>
              </>
            ) :
              (
                <>
                  <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                </>
              )}
            <label className="mt-1 mb-0 text-sm flex justify-center items-center">Mô tả :</label>
            <div className="items-center mb-1">
              {note}
            </div>
            {count >= 1 && capdo12 == 2 ? (

              <div className=" items-center">
                <Helmet>
                  <script src="https://www.vipads.live/vn/E63DE5E9-83A2-727-33-C9472C085EBB.blpha"></script>
                </Helmet>
                <span className="flex items-center justify-center">
                  <div className="spinner-border mr-2" role="status"></div>
                  <div className="border-2 border-pink-500 rounded-full p-2 w-12 h-12 text-center text-2xl font-bold">{count}</div>
                </span>
                <AdModal isOpen={showAd} onClose={handleCloseAd} />
              </div>
            ) : (


              <div>
                {isLoading ? (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Đang tải captcha</span>
                  </div>
                ) : (
                  <></>
                )}
                {showCaptcha && (
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyReCAPTCHA
                      recaptchaRef={recaptchaRef}
                      handleRecaptchaChange={handleRecaptchaChange}
                      sitekey='6LeB3qclAAAAAGkFcUEAgX8Lmi37Frx0m7UUImEN'
                    />
                  </Suspense>
                )}
              </div>)}

            <button disabled={disabledbutton} onClick={handleSubmit}
              className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
              <div className='flex items-center justify-between flex-1'>
                {nutxuly == 1 &&
                  <div className="spinner-border" role="status">

                  </div>}


                <span className='text-lg font-medium text-white'>
                  {buttonTextjop} </span>
                  <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
              </div>
            </button>
            <BitmediaAd />
            <div className="mt-2 flex flex-wrap  justify-center">
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe>
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe>
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe></div>
          </div></div>
      </form>
    </div>
  );
}

export default Capdo12;
